import Cookies from "js-cookie";
import moment from "moment";
import { handleFetchApi } from "../configs/apiRequest";
import { message, notification } from "antd";
import { AAUTH } from "../apis/auth";

export const returnLogin = () => {
    if (window.location.pathname !== "/login")
        setTimeout(() => {
            window.location = `/login?callback=${window.location.pathname}`;
        }, 1000);
};

const clearCookie = (name) => {
    Cookies.remove(name, { domain: ".cloudbook.vn" }); // new: shared subdomain
    Cookies.remove(name, { domain: "app.cloudbook.vn" }); // old: specific subdomain
    Cookies.remove(name); // fallback: localhost / no domain
};

export const logout = () => {
    clearCookie("user_id");
    clearCookie("refresh_token");
    clearCookie("access_token");
    clearCookie("role");
    returnLogin();
};

export const removeItemFromArray = (array, item) => {
    return array.filter((element) => element.id !== item);
};

export const toggleItemArray = (array, item) => {
    var index = array.indexOf(item) || array.findIndex((element) => element.id === item?.id);

    if (index === -1) {
        array.push(item);
    } else {
        array.splice(index, 1);
    }
    return array;
};

export const getMe = async () => {
    const profile = await handleFetchApi(AAUTH.getProfile());
    const { school_classes = [] } = profile?.data;
    const classData = {
        className: school_classes[0]?.name,
        grade: school_classes[0]?.grade,
        classId: school_classes[0]?.id,
        schoolId: school_classes[0]?.school?.id,
        schoolName: school_classes[0]?.school?.name,
    };
    return { ...profile?.data, ...classData };
};

export const checkValidSesson = async (me, setMe) => {
    let session_id = window.location.pathname.split("/")[2];
    // // Not login
    if (!Cookies.get("access_token") && !session_id) {
        returnLogin();
        return;
    }
    if (!me) {
        let profile = await getMe();
        setMe(profile);
        return profile;
    }
    return me;
};

export const checkValidResponse = (response) => {
    if (!response) return;
    if (response?.status === "UR0015") {
        // Authentication failed
        returnLogin();
        return false;
    }
    return true;
};

// Short-circuiting, and saving a parse operation
export const isInt = (value) => {
    var x;
    if (isNaN(value)) {
        return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
};

export const toggleFullscreen = () => {
    if (
        !document.fullscreenElement && // alternative standard method
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
    ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        }
    }
};

export function debounce(func, timeout = 300) {
    let lastCalled;
    return (...args) => {
        clearTimeout(lastCalled);
        lastCalled = setTimeout(() => {
            func.apply(this, args);
        }, timeout || 300);
    };
}

export function throttle(func, delay = 1000) {
    let lastCalled = new Date().getTime();

    return (...args) => {
        const now = new Date().getTime();
        if (now - lastCalled < delay) {
            return;
        }
        lastCalled = now;
        func.apply(this, args);
    };
}

export const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().startOf("day");
};

export const isNumeric = (str) => {
    if (typeof str != "string") return false; // we only process strings!
    return (
        !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
};

export const isEmpty = (data) => {
    for (const prop in data) {
        if (Object.hasOwn(data, prop)) {
            return false;
        }
    }

    return true;
};
export const isEmptyFill = (data) => {
    for (const key in data) {
        if (Object.hasOwn(data, key) && data[key] !== null && data[key] !== "") {
            return false;
        }
    }

    return true;
};

export const renderParams = (list, key) => {
    if (!list) return "";
    let params = "";
    list.forEach((element) => {
        params += `${key}=${element}&`;
    });
    return params.replace(/&$/, "");
};

export const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
        // Extract the key value from the current element
        const groupKey = currentValue[key];

        // Initialize the group if it doesn't exist
        if (!result[groupKey]) {
            result[groupKey] = [];
        }

        // Add the current element to the group
        result[groupKey].push(currentValue);

        return result;
    }, {});
};

export const groupByCustomKey = ({ array, logical }) => {
    return array?.reduce((acc, current) => {
        const key = logical(current);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(current);
        return acc;
    }, {});
};

export function copyText(textToCopy) {
    navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
            notification.success({ message: "Đã copy đường link đến bài kiểm tra!" });
            // Optionally, show a success message to the user
        })
        .catch((err) => {
            notification.success({ message: "Trình duyệt không hỗ trợ chức năng này!" });
            // Optionally, show an error message to the user
        });
}

export function isMobile() {
    const userAgent = navigator.userAgent.toLowerCase();
    console.log("userAgent::", userAgent);

    if (/mobile|android|iphone|ipod|blackberry|opera mini|iemobile|webos/.test(userAgent)) {
        return true;
    } else {
        return false;
    }
}

export const imageFallback = `data:image/png;base64,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`;
